import React from 'react';
import {Alert, Box, Typography} from '@mui/material';
import { PropertyDefinitionBelongsTo, PropertyDefinitionHas, PopulatedEntry, EntityType, BelongsToPopulatedValue } from '../types';
import { EntryPropertyBelongsToBlock, EntryPropertyMultilineTextBlock, EntryPropertyTextBlock } from './EntryProperty';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { PropertyDefinition } from '../types';
import { isEntryTimestampPropertyDefinition } from '../common/util';

export function EntryContentSimple({
	disableTabIndex,
	disableMetaFieldEdit = false,
	readOnly = false,
	onRelationDialogOpen,
	onScalarFieldEdit,
	propertyDefinitions,
	populatedEntry,
}: {
	disableTabIndex: boolean;
	/** When true, `created-at` / `updated-at` are read-only (server-owned timestamps). */
	disableMetaFieldEdit?: boolean;
	readOnly?: boolean;
	onRelationDialogOpen?: (def: PropertyDefinitionBelongsTo | PropertyDefinitionHas) => void;
	onScalarFieldEdit?: (entry: PopulatedEntry, def: PropertyDefinition) => void;
	propertyDefinitions: PropertyDefinition[];
	populatedEntry: PopulatedEntry;
}) {
	const data = populatedEntry.data;
	const isEntryArchived = populatedEntry.isArchived;
	return (<>
		{propertyDefinitions.map((def) => {
			const isFieldEditDisabled =
				readOnly ||
				Boolean(isEntryArchived) ||
				(disableMetaFieldEdit && isEntryTimestampPropertyDefinition(def));
			if (def.type === EntityType.PropertyDefinitionBelongsTo || def.type === EntityType.PropertyDefinitionHas) {
				const relationDef = def as PropertyDefinitionBelongsTo | PropertyDefinitionHas;
				const values = (data[relationDef.slug] ?? []) as BelongsToPopulatedValue[];
				return (
					<div key={`${relationDef.id}`}>
						<EntryPropertyBelongsToBlock
							disableTabIndex={disableTabIndex}
							def={relationDef}
							values={values}
							onDialogOpen={() => onRelationDialogOpen?.(relationDef)}
							disabled={isFieldEditDisabled}
						/>
						<br />
					</div>
				);
			}
			if (def.type === EntityType.PropertyDefinitionText) {
				return (
					<div key={`${def.id}`}>
						<EntryPropertyMultilineTextBlock
							def={def}
							value={(data[def.slug] ?? '') as string}
							disabled={isFieldEditDisabled}
							onEditClick={isFieldEditDisabled ? undefined : () => onScalarFieldEdit?.(populatedEntry, def)}
						/>
						<br />
					</div>
				);
			}
			return (
				<div key={`${def.id}`}>
					<EntryPropertyTextBlock
						def={def}
						value={(data[def.slug] ?? '') as string}
						disabled={isFieldEditDisabled}
						onEditClick={isFieldEditDisabled ? undefined : () => onScalarFieldEdit?.(populatedEntry, def)}
					/>
					<br />
				</div>
			);
		})}
		<Box display='flex' justifyContent='center'>
			{isEntryArchived && <Alert icon={<LockOutlinedIcon />} severity='info' sx={{ boxShadow: 'none' }} elevation={0}><Typography variant='body1' color='text.secondary'>This entry is archived.</Typography></Alert>}
		</Box>
	</>
	);
}